
import { CellGroup, Cell, PullRefresh } from 'vant'
import { mapState } from 'vuex'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
// import ldPay from 'Components/ldPay/index.vue'
import DetailPanel from '../visaQuery/visaDetail/DetailPanel'
import handle from './handle'

import { KdPayMethods } from 'Domain/use-cases/visa-book-interactor'
import VisaOrderInteractor from 'Domain/use-cases/visa-order-interactor'

export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [PullRefresh.name]: PullRefresh,
    ldButton,
    ldTabbar,
    // ldPay,
    DetailPanel
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isLoading: false,
      detail: {}, // 正常单详情
      showProgress: false, // 展示办理进度
      progressList: []
    }
  },
  created () {
    this.getDetail()
  },
  methods: {
    async getDetail() {
      this.isLoading = true
      
      const { data } = await VisaOrderInteractor.getDetailById(this.id)

      this.isLoading = false
      this.detail = data
      this.getProgress()
    },
    async getProgress () {
      const { data } = await VisaOrderInteractor.getProgress(this.id)
      this.progressList = data
    },
    async btnClick (handleType) {
      // 是否二次送审 登录人 bookStyle 是单订模式 1，还是出差申请单模式  2
      var bookStyle = this.vipCorp.bookStyle
      if (bookStyle == 2) {
        this.detail.againApp = 1
      } else {
        this.detail.againApp = 0
      }
      
      if (handle[handleType]) {
        await handle[handleType](this.detail)
        this.getDetail()
      }
    },
    pay() {
      // this.$refs.pay.toggle()
      this.$router.push({path:'/pay/payment',query:{orderType:this.detail.orderType,orderId:this.id}})
    }
  },
  computed: {
    // 电子签的 不用显示寄回信息  快递费 和补填寄送信息这些
    showAddress () {
      return this.detail.visaForm !== '0'
    },
    priceList () {
      const num = this.detail.personList && this.detail.personList.length
      const SalePrice = this.detail.xsj / num
      const Kdf = this.detail.kdf
      const ServiceFee = this.detail.fwf / num
      let rt = [
        { name: '价格', price: SalePrice, amount: num,	unit: '人' }
      ]
      
      if (this.showAddress && this.detail.kdPayMethod == KdPayMethods[1].key) rt.push({ name: '快递费', price: Kdf })
      if (ServiceFee > 0) rt.push({ name: '服务费', price: ServiceFee, amount: num,	unit: '人' })
      
      return rt
    },
    ...mapState({
      vipCorp: state => state.app.userInfo.vipCorp
    })
  }
}